import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { LOT } from '../types/lot.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Lot entity.
 * Stored in 'org/{orgId}/lot' — PostgresRest (ledger will FK/filter by lot).
 */
export const lotDescriptor = {
    name: LOT,
    label: 'Lote',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/lot',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 2,
    description: 'Traceability lot — references a partial ProductVariant (0106)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique lot identifier',
        },
        {
            name: 'lotNumber',
            example: 'L-2026-10-031',
            label: 'Número do lote',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
            description: 'Digitable lot number; unique per (org, productId)',
        },
        {
            name: 'productId',
            label: 'Produto',
            type: 'string',
            required: true,
            description: 'Owning product',
        },
        {
            name: 'variantId',
            label: 'Variante',
            type: 'string',
            required: false,
            description: 'Partial ProductVariant (identifying axes); required when product varies',
        },
        {
            name: 'productionDate',
            example: '2026-10-22',
            label: 'Data de fabricação',
            type: 'date',
            required: false,
            description: 'Manufacturing date (may be in the future)',
        },
        {
            name: 'expiryDate',
            example: '2027-10-22',
            label: 'Data de validade',
            type: 'date',
            required: false,
            description: 'Expiry date; required when product stockHasExpiry is effective',
        },
        {
            name: 'plannedQuantity',
            example: 250,
            label: 'Quantidade planejada/produzida',
            type: 'number',
            required: false,
            description: 'Informative planned/produced quantity — not the lot balance (ledger, fase D)',
        },
        {
            name: 'supplierId',
            label: 'Fornecedor',
            type: 'string',
            required: false,
            description: 'Origin supplier party (purchase lots)',
        },
        {
            name: 'notes',
            example: 'Lote da OP 1001',
            label: 'Observações',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Free-text notes',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Owning product',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Partial product variant (identity)',
        },
        {
            fieldName: 'supplierId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
            description: 'Origin supplier',
        },
    ],
};
//# sourceMappingURL=lot.descriptor.js.map